export type SmsTestAuthApiResponse =
  /** status 200 Standard response */
  | {
      [key: string]: any; // eslint-disable-line typescript/no-explicit-any -- Pre-existing any
    }
  | /** status 204 Standard response */ void;
export type SmsTestAuthApiArg = {
  tenantId?: string | null;
};
export type SmsGetKonzultaCredentialsApiResponse =
  | /** status 200 Standard response */ ({
      username?: string | null;
      enabled?: boolean | null;
    } | null)
  | /** status 204 Standard response */ void;
export type SmsGetKonzultaCredentialsApiArg = void;
export type SmsPatchKonzultaCredentialsApiResponse = unknown;
export type SmsPatchKonzultaCredentialsApiArg = {
  body: {
    username?: string | null;
    password?: string | null;
    enabled?: boolean | null;
  } | null;
};
export type SmsPostMessageKonzultaApiResponse =
  | /** status 200 Standard response */ ({
      SmsServices?: {
        DataHeader?: {
          DataType: string | null;
        } | null;
        DataArray?: {
          DataItem?: {
            SmsId: string | null;
            Status: number | null;
          } | null;
          DataTemplate?: {
            [key: string]: any; // eslint-disable-line typescript/no-explicit-any -- Pre-existing any
          } | null;
        } | null;
      } | null;
    } | null)
  | /** status 204 Standard response */ void;
export type SmsPostMessageKonzultaApiArg = {
  body: {
    SmsServices?: {
      DataHeader?: {
        DataType?: string | null;
        UserName: string | null;
        Password: string | null;
      } | null;
      DataArray?: {
        DataTemplate?: {
          DataItem?: {
            ContentType?: string | null;
            MobileTerminate: string | null;
            Text: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};
export type SmsPostMessageApiResponse =
  | /** status 200 Standard response */ ({
      message?: ({
        phone?: string | null;
        status?: number | null;
      } | null)[];
    } | null)
  | /** status 204 Standard response */ void;
export type SmsPostMessageApiArg = {
  /** PL only */
  normalize?: boolean | null;
  /** PL only */
  skipForeign?: boolean | null;
  /** PL only */
  from?: string | null;
  /** PL only */
  maxParts?: number | null;
  /** PL only */
  id?: string | null;
  authorization: string | null;
  tenantId?: string | null;
  body: {
    phone?: (string | null)[];
    message?: string | null;
  } | null;
};
